import { Component, inject, model, ChangeDetectionStrategy } from '@angular/core';
import { IPromocionImpresoraData } from '@core/interfaces/entidades/promocion-impresora.entidad';
import { PromocionImpresoraApiService } from '@core/services/api/promocion-impresora-api.service';
import { UiDialog } from '@shared/components/ui';
import { EditarPromocionImpresora } from './editar-promocion-impresora/editar-promocion-impresora';

@Component({
	selector: 'app-card-promocion-impresora',
	imports: [UiDialog, EditarPromocionImpresora],
	templateUrl: './card-promocion-impresora.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrl: './card-promocion-impresora.css',
})
export class CardPromocionImpresora {
	private api = inject(PromocionImpresoraApiService);
	modal_editar = model(false);
	promocion = model.required<IPromocionImpresoraData>();

	onEditar() {
		this.modal_editar.set(true);
	}
	closeEditar(data?: IPromocionImpresoraData) {
		this.modal_editar.set(false);
		if (data) {
			this.promocion.set(data);
		}
	}
	toggleStatus() {
		this.api.toggle(this.promocion().id).subscribe((data) => {
			this.promocion.set(data);
		});
	}
}
